export default [
  {
    path: '',
    name: 'lawyerFlow',
    meta: {
      title: '购买确认',
      activity: true
    },
    component: () => import('@/views/lawyerFlowPacket/index.vue')
  },
  {
    path: 'password',
    name: 'lawyerFlowPassword',
    meta: {
      title: '验证码确认',
      activity: true
    },
    component: () => import('@/views/lawyerFlowPacket/password.vue')
  },
  {
    path: 'result',
    name: 'lawyerFlowResult',
    meta: {
      title: '支付',
      activity: true
    },
    component: () => import('@/views/lawyerFlowPacket/payResult.vue')
  },
]